// extracted by mini-css-extract-plugin
export default {"main":"CustomInput_main__bazhB","input":"CustomInput_input__jvwsu"};